module.exports = __webpack_public_path__ + "static/img/solutions-1-1.fda3a42.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/solutions-1-1.png
// module id = Mr+l
// module chunks = 1